<template>
  <div
    v-if="user.id != subAccount.sub_account.id"
    class="sub-account"
  >
    <div @click="handleClick">
      <h4>{{ subAccount.sub_account.name }}</h4>
      <h5>{{ subAccount.sub_account.email }}</h5>
    </div>

    <feather-icon
      v-if="!submitting && !subAccount.main"
      size="16"
      icon="XSquareIcon"
      class="icon logged_out-icon mr-50"
      @click="handleClickDelete"
    />
    <b-spinner
      v-show="submitting"
      class="spinner"
    />
    <ok-confirm-modal
      v-if="showConfirmation"
      :show-cancel="true"
      :text="$t('users.confirm-delete-account')"
      :pre-confirm="removeSubAccount"
      @cancel="showConfirmation=false"
    />
  </div>

</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import OkConfirmModal from '@/@okmenu/components/modals/OkConfirmModal'

export default {
  name: 'SubAccount',

  components: { OkConfirmModal, BSpinner },
  props: {
    subAccount: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      submitting: false,
      showConfirmation: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  methods: {
    handleClick() {
      this.submitting = true
      const mainEmail = localStorage.getItem('main_account')
      let payload = { sub_id: this.subAccount?.sub_account?.id, main_account: mainEmail }
      if (this.subAccount?.main) {
        payload = { email: this.subAccount?.sub_account?.email, main: 1, main_account: mainEmail }
      }
      this.$emit('switch', payload)
    },
    handleClickDelete() {
      this.showConfirmation = true
    },
    removeSubAccount() {
      this.$store.dispatch('auth/DELETE_SUB_ACCOUNT', { sub_id: this.subAccount.sub_account.id, main_account: localStorage.getItem('main_account') })
        .then(() => {
          this.$emit('delete')
          this.showConfirmation = false
        })
    },
  },
}
</script>

<style scoped>
    .sub-account{
        background-color: #eee;
        padding: 1rem;
        margin: 1rem;
        cursor: pointer;
        position: relative;
    }
    .icon{
        position: absolute;
        top: 50%;
        right: 4%;
        transform: translate(-50%, -50%);
    }
    .check-icon{
        color: green;
    }
    .logged_out-icon{
        color: red;
    }
    .spinner{
        position: absolute;
        top: 35%;
        right: 4%;
    }

</style>
